// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#too-soon-warning .warning-message {
  margin: 0.5rem 0 1rem;
  text-align: center;
}

#too-soon-warning .time-since {
  font-weight: bold;
  font-size: 2rem;
  color: var(--soft-red-color);
}

#too-soon-warning .warning-button {
  font-size: 1.8rem;
  margin: 0.5rem;
  color: white;
  border-radius: 999px;
  padding: 0.5rem 0.5rem;
  cursor: pointer;
}

#too-soon-warning .save {
  font-size: 1.2rem;
  background-color: var(--soft-red-color);
  border: 2px solid var(--soft-red-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/TooSoonWarningModal.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,uCAAuC;AACzC","sourcesContent":["#too-soon-warning .warning-message {\n  margin: 0.5rem 0 1rem;\n  text-align: center;\n}\n\n#too-soon-warning .time-since {\n  font-weight: bold;\n  font-size: 2rem;\n  color: var(--soft-red-color);\n}\n\n#too-soon-warning .warning-button {\n  font-size: 1.8rem;\n  margin: 0.5rem;\n  color: white;\n  border-radius: 999px;\n  padding: 0.5rem 0.5rem;\n  cursor: pointer;\n}\n\n#too-soon-warning .save {\n  font-size: 1.2rem;\n  background-color: var(--soft-red-color);\n  border: 2px solid var(--soft-red-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
